import { useState } from 'react';
import { Snackbar } from '@mui/material';

interface TextGenerationModalsProps {
  // 설정 모달 관련 props 제거됨 / Settings modal props removed
}

const TextGenerationModals = ({}: TextGenerationModalsProps) => {
  const [showCopySnackbar, setShowCopySnackbar] = useState(false);

  return (
    <>
      {/* 복사 완료 알림 / Copy Success Notification */}
      <Snackbar
        open={showCopySnackbar}
        autoHideDuration={2000}
        onClose={() => setShowCopySnackbar(false)}
        message="복사되었습니다!"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  );
};

export default TextGenerationModals;
